import { requests } from ".";
import config from "../config";

export const CompanyService = {
  getById: (companyId: string) => requests().get("/companies/" + companyId),
  exportDetails: async (companyId: string) => {
    const { data } = await requests(config.REVEX_BACKEND_LC_PHONE_URL).get(
      `/sub-account/export-sub-accounts-details/${companyId}`
    );
    return data;
  },
  updateEmailList: async (companyId: string, emailList: string[], defaultEmail: string) => {
    try {
      const { data } = await requests(config.REVEX_BACKEND_LC_PHONE_URL).post(
        `/sub-account/emails?companyId=${companyId}`,
        {
          emailList,
          defaultEmail,
        }
      );
      return data;

    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  },
  getEmailList: async (companyId: string) => {
    const { data } = await requests(config.REVEX_BACKEND_LC_PHONE_URL).get(
      `/sub-account/emails?companyId=${companyId}`
    );
    return data;
  },
  getSubAccountCountUsingLcPhone: async (companyId: string) => {
    const { data } = await requests(config.REVEX_BACKEND_LC_PHONE_URL).get(
      `/sub-account/count/lc-phone?companyId=${companyId}`
    );
    return data;
  }
};
